<ng-template #content let-c="close" id="modal">

  <div class="modal-header">
    <h4 class="modal-title">Program Licenses for {{accountName}} at {{organizationName}}</h4>

    <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()">
    </button>
  </div>


  <div class="modal-body">
    <div *ngIf="isLoading" class="licenses-loader">
      <i class="fas fa-spinner  fa-spin fa-lg  icons"> </i>
    </div>
    <div *ngIf="!isLoading" class="container-fluid">
      <div class="mb-3">
        <div class="row titles mt-4">
          <div class="col-md-4">Program(s)</div>
          <div class="col-md-8 ps-0">
            <span class="grades"> Grade(s) </span>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let program of accountPrograms">
        <div class="d-flex mb-4">
          <button disabled class="form-control-sm btn-primary btn-square program-btn me-2"
                  [ngClass]="{ 'selected': isProgramProductSelected(program.products) }">
            {{ program.name }}
          </button>

          <div class="w-500px">
            <div *ngFor="let product of sortProducts(program.products)"
                 class="product">
              <input type="checkbox"
                     class="custom-selectors"
                     #productCheckbox
                     [checked]="product.assigned"
                     [disabled]="!hasPermissionToEdit"
                     [class.disabled]="!hasPermissionToEdit"
                     (change)="selectLicense($event, product)"/>
              {{ product.displayName }}
            </div>
          </div>
        </div>
      </ng-container>

      <br>
      <button *ngIf="!allSelected"
              class="select-all btn-transparent border-0"
              (click)="selectAll()"
              [hidden]=" !hasPermissionToEdit">
        Select All
      </button>

      <button *ngIf="allSelected"
              class="select-all btn-transparent border-0"
              (click)="unSelectAll()"
              [hidden]=" !hasPermissionToEdit">
        Unselect All
      </button>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button"
            class="btn btn-cancel"
            (click)="onDismiss()">
      Cancel
    </button>
    <button type="submit"
            class="btn-primary btn-save"
            [disabled]="!isEditing"
            (click)="onSubmit()">
      Save
    </button>
  </div>

</ng-template>


<ccc-confirm-modal #confirmModal
                   (confirmAction)="onCloseConfirmModal($event)">
</ccc-confirm-modal>
<ccc-confirm-modal #modalCancel
                   (confirmAction)="onCloseConfirmModal($event)"
                   confirmMessage="Are you sure you want cancel current changes?">
</ccc-confirm-modal>
